<template>
  <div>
    <h5>
      {{ $t('Advertisables.view.title') }}
    </h5>

    <post-list
      class="container"
      editable
      :displayList="getPaginatedList"
      :paginationInfo="getPaginationInfo"
      @deletePost="deletePost"
      @requestPrevPage="requestPrevPage()"
      @requestNextPage="requestNextPage()">

      <div
        slot="filterSlot"
        class="select-inputs-products col-md-3 p-sm-0 col-sm-12">

        <input-select
          :inputPlaceholder="$t('Campaigns.filterCategoriesPlaceholder')"
          inputName="category"
          class="select-input"
          variant="standardInput"
          :inputLabel="$t('Campaigns.filterCategories')"
          small
          :selectOptions="getAdvertisableCategories"
          @fieldUpdate="updateFilter" />
        
      </div>

      <div
        slot="filterSlot"
        class="search-box-container col-md-3 p-sm-0 col-sm-12">

        <input-text
          iconRight="search"
          :inputLabel="$t('Campaigns.findProduct')"
          small
          regular
          class="col" 
          variant="standardInput"
          :inputPlaceholder="$t('Campaigns.findProduct')"
          inputName="query"
          @fieldUpdate="updateFilter" />

      </div>
    </post-list>
  </div>
</template>

<script>
import PostList from '@/components/standard/display/PostList'
import advertisables from '@/mixins/pagination/providers/advertisables'
import apiConnector from '@/mixins/apiConnector.js'
import fieldBuilder from '@/assets/modules/apollo/fieldBuilder'
import nManager from '@/assets/modules/notifications/manager'
import resolver from '@/assets/modules/error/resolver'

import InputSelect from '@/components/standard/input/InputSelect'
import InputText from '@/components/standard/input/InputText'

export default {
  methods: {
    /**
     * Requests previus page
     * @param {Object} e JS event
     */
    requestPrevPage (e) {
      this.prevPage()
    },

    /**
     * Requests next page
     * @param {Object} e JS event
     */
    requestNextPage (e) {
      this.nextPage()
    },

    /**
     * Requests to deleta a post
     * @param {Object} e Target advertisable
     */
    deletePost (e) {
      let okCallback = (e) => {
        nManager.okNotification(this, 'Notification.ok.contentRemoved.label')
        this.refetch()
      }

      let failCallback = (_, e) => {
        let message = 'Vsebina ni bila odstranjena!'
        message = resolver.resolve(e.message, message)
        nManager.nokNotification(this, message)
        this.refetch()
      }

      let {mutationString, dataObject, name} = fieldBuilder
        .buildGqlObject(e, 'deleteAdvertisable', 'mutation')

      this.sendMutation(
        mutationString,
        dataObject,
        okCallback,
        failCallback,
        name)
    }
  },

  computed: {
    /**
     * Tells if categorie dropdown is disabled
     * @returns {Boolean}
     */
    categoriesEnabled () {
      return !!this.getAdvertisableCategories.length
    }
  },

  components: {
    'post-list': PostList,
    'input-select': InputSelect,
    'input-text': InputText
  },

  mixins: [
    advertisables,
    apiConnector
  ]
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/service/postManager/PostViewer.vue?230f1aa1